import { types } from 'mobx-state-tree'

export const QuizPctCorrectSummary = types.model('QuizPctCorrectSummary').props({
  pct_correct: types.number,
  quiz_id: types.number,
  quiz_title: types.string,
})
